interface ConfirmNewMenuModalProps {
  onCancel: () => void
  onConfirm: () => void
}

export const ConfirmNewMenuModal = ({ onCancel, onConfirm }: ConfirmNewMenuModalProps) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg p-6 max-w-md w-full">
      <h3 className="text-lg font-medium text-custom-dark mb-4">
        Creating a new menu will reset your current one, and any changes will be lost.
      </h3>
      <div className="flex items-center justify-end space-x-3">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="px-4 py-2 text-sm font-medium text-white rounded-md hover:opacity-80 bg-brand-primary"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
)
